/* eslint-disable import/order */
/* eslint-disable global-require */
import React, { useState, useEffect, useRef } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { IconButton, Button, makeStyles, Grid, Box } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import ptLocale from '@fullcalendar/core/locales/pt-br'

import {
  findAttendantes,
  getServicesBooked,
} from '../../callendar/CalendarActions'
import Chips from '../../callendar/pages/chips'
import {
  mdiCalendarMultiple,
  mdiCash,
  mdiChevronLeft,
  mdiChevronRight,
} from '@mdi/js'
import Icon from '@mdi/react'
import colors from '../../../assets/colors'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import BasePopUp from '../../../components/hooks/BasePopUp'
import { exportFormatedMoney } from '../../../util/utils'

const useStyles = makeStyles({
  btnCalendar: {
    color: colors.sucess,
    fontSize: '14px',
    backgroundColor: colors.bgSucess,
    borderRadius: '10px',
    padding: '4px 12px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      opacity: 0.6,
      backgroundColor: colors.bgSucess,
    },
  },
})

function CashbackModal(props) {
  const styles = useStyles()

  const [open, setOpen] = useState(false)

  const cashback = useSelector(state => state.client.cashback)

  const handleClickOpen = () => {
    setOpen(!open)
  }

  return (
    <>
      <IconButton className={styles.btnCalendar} onClick={handleClickOpen}>
        <Icon path={mdiCash} size={1} style={{ marginRight: '4px' }} />
        Cashback Disponível
      </IconButton>

      <BasePopUp
        open={open}
        handleOpen={handleClickOpen}
        title="Cashback disponível"
        message={`Cliente possuí ${
          cashback?.total_points
        } pontos ou R$ ${exportFormatedMoney(
          cashback?.total_points * cashback?.cashback_point_value
        )} reais de cashback disponível`}
        type="sucess"
      />
    </>
  )
}

export default CashbackModal
